(() => {
  'use strict';
  // Work from the displayed, already-rounded payable unit price. Never apply
  // a percentage to the (already rounded) UVP reference price.
  const scale = {ml:1n, l:1000n, g:1n, kg:1000n, mm:1n, cm:10n, m:1000n};
  const money = /(?:\d{1,3}(?:[.,\s\u00a0]\d{3})+|\d+)[.,]\d{2}(?!\d)/;
  function cents(text) {
    const hit=String(text).match(money); if(!hit) return null;
    const raw=hit[0].replace(/\s/g,'');
    const digits=raw.replace(/[.,]/g,'');
    return /^\d+$/.test(digits) ? BigInt(digits) : null;
  }
  function fixed(value) {
    const match=String(value).match(/^(\d+)(?:\.(\d{1,6}))?$/);
    return match ? BigInt(match[1])*1000000n+BigInt((match[2]||'').padEnd(6,'0')) : null;
  }
  function unitCents(price, measurement) {
    const q=fixed(measurement.quantity_value),r=fixed(measurement.reference_value);
    const qs=scale[String(measurement.quantity_unit).toLowerCase()],rs=scale[String(measurement.reference_unit).toLowerCase()];
    if(price===null || q===null || r===null || !qs || !rs || q<=0n || r<=0n) return null;
    const numerator=price*r*rs, denominator=q*qs;
    return (numerator*2n+denominator)/(denominator*2n);
  }
  function payable(block) {
    const spans=Array.from(block.children).filter(e=>e.tagName==='SPAN' && !getComputedStyle(e).textDecorationLine.includes('line-through') && !e.classList.contains('visually-hidden'));
    for(let i=spans.length-1;i>=0;i--) { const value=cents(spans[i].textContent);if(value!==null)return value; }
    const direct=Array.from(block.childNodes).filter(e=>e.nodeType===3).map(e=>e.textContent).join(' ');
    return cents(direct);
  }
  function correct(block,measurement) {
    const value=unitCents(payable(block),measurement);if(value===null)return;
    const formatted=new Intl.NumberFormat(document.documentElement.lang||'de-DE',{minimumFractionDigits:2,maximumFractionDigits:2}).format(Number(value)/100);
    for(const unit of Array.from(block.children).filter(e=>e.tagName==='SMALL')) {
      // Only replace the number, preserving the reference unit and currency.
      const walker=document.createTreeWalker(unit,NodeFilter.SHOW_TEXT);let node;
      while((node=walker.nextNode())) {
        if(!money.test(node.nodeValue))continue;
        const next=node.nodeValue.replace(money,formatted);
        if(next!==node.nodeValue)node.nodeValue=next;
      }
    }
  }
  function update() {
    const measurements=new Map();
    document.querySelectorAll('script[data-nlx-unit-data]').forEach(el=>{
      try {const data=JSON.parse(el.textContent);if(data.currency!=='EUR')return;
        data.variants.forEach(v=>{if(v.measurement)measurements.set(String(v.id),v.measurement);});
      } catch (_) { /* Invalid or incomplete dynamic sections stay native. */ }
    });
    document.querySelectorAll('.price[bss-b2b-product-active="true"][bss-b2b-variant-id]').forEach(block=>{
      const m=measurements.get(block.getAttribute('bss-b2b-variant-id'));if(m)correct(block,m);
    });
    document.querySelectorAll('[bss-b2b-item-original-price],[bss-b2b-item-final-price]').forEach(block=>{
      const id=(block.getAttribute('bss-b2b-cart-item-key')||'').split(':')[0];
      const m=measurements.get(id);if(m)correct(block,m);
    });
  }
  let pending=false;
  const schedule=()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;observer.disconnect();try{update();}finally{observer.observe(document.body,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['bss-b2b-variant-id','bss-b2b-product-active']});}});};
  const observer=new MutationObserver(schedule);
  if(document.body){observer.observe(document.body,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['bss-b2b-variant-id','bss-b2b-product-active']});schedule();}
  document.addEventListener('shopify:section:load',schedule);
})();
